import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import UpdateDmxControllerForm from '../../components/Forms/UpdateDmxControllerForm';

class DmxControllerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controller: this.props.location.state || null,
    };
  }

  componentDidMount() {
    if (!this.state.controller) {
      this.props.history.push('/dmxControllers');
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.push('/dmxControllers');
  }

  render() {
    const { controller } = this.state;
    if (!controller) return null;
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <UpdateDmxControllerForm controller={controller} />
        </Container>
      </div>
    );
  }
}

export default withRouter(withNamespaces()(DmxControllerDetails));
